export const router = {
  1: "0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D",
  25: "0xcd7d16fB918511BF7269eC4f48d61D79Fb26f918",
  56: "0x10ED43C718714eb63d5aA57B78B54704E256024E",
  137: "0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506",
  43114: "0x60aE616a2155Ee3d9A68541Ba4544862310933d4",
};
export const factory = {
  1: "0x5C69bEe701ef814a2B6a3EDD4B1652CB9cc5aA6f",
  25: "0x73A48f8f521EB31c55c0e1274dB0898dE599Cb11",
  56: "0xca143ce32fe78f1f7019d7d551a6402fc5350c73",
  137: "0xc35DADB65012eC5796536bD9864eD8773aBc74C4",
  43114: "0x9Ad6C38BE94206cA50bb0d90783181662f0Cfa10",
};
export const providerRpc = {
  1: "https://cloudflare-eth.com/",
  25: "https://evm-cronos.crypto.org/",
  56: "https://bsc-dataseed1.ninicoin.io/",
  137: "https://polygon-rpc.com/",
  43114: "https://api.avax.network/ext/bc/C/rpc",
};
